// Pages in the homepage webring. Prev / next wrap this list.
export const webring = [
  { href: '/', label: 'Home' },
  { href: '/portfolio', label: 'Apps' },
  { href: '/blog', label: 'Blog' },
  { href: '/tyler', label: 'Tyler' },
  { href: '/guestbook', label: 'Guestbook' },
];
